/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Apps from './Apps/index'
import AvatarAndName from './AvatarAndName/index'
import ClockInAction from './ClockInAction/index'
import EmployeeWorkHoursAction from './EmployeeWorkHoursAction/index'
import FinancialAction from './FinancialAction/index'
import FloatingPortal from 'DesignSystem/FloatingPortal/react'
import KpisAction from './KpisAction/index'
import LocationAction from './LocationAction/index'
import LogoutAction from './LogoutAction/index'
import MarketingAction from './MarketingAction/index'
import NotesAction from './NotesAction/index'
import OrdersAction from './OrdersAction/index'
import PatientsAction from './PatientsAction/index'
import React from 'react'
import ReportsAction from './ReportsAction/index'
import RoadmapAction from './RoadmapAction/index'
import SettingsAction from './SettingsAction/index'
import SupportAction from './SupportAction/index'
import TysiaHorizDivider from 'DesignSystem/TysiaHorizDivider/index'
import WorkHoursAction from './WorkHoursAction/index'
import WorkflowsAction from './WorkflowsAction/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import useIsMedia from 'Simple/hooks/useIsMedia'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Topbar/Options/Content",
  innerRef
  
}) {
  let isBefore = useIsBefore()
  let isMedia = useIsMedia()
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
  return (<React.Fragment
>
<FloatingPortal
  viewPath={`${viewPath}/FloatingPortal`}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 ref={innerRef}
 style={{'--bc-2-Z1Yf8zk': dtColorsWhite,'--bc-3-Z1Yf8zk': dtColorsNeutral200,'--btlr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-7-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-9-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-10-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--r-11-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--o-8-Z1Yf8zk': isBefore ? 0 : 1,'--ty-12-Z1Yf8zk': isBefore ? "-4px" : "0px",'--p-1-Z1Yf8zk': isMedia.mobile ? "absolute" : "absolute"}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<AvatarAndName
  viewPath={`${viewPath}/AvatarAndName`}
/>
<LocationAction
  viewPath={`${viewPath}/LocationAction`}
/>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-13-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-14-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 backgroundColor={dtColorsNeutral200}
 marginBottom={dtSpaceXxs}
 marginTop={dtSpaceXxs}
/>
</div>
<ClockInAction
  viewPath={`${viewPath}/ClockInAction`}
/>
<WorkHoursAction
  viewPath={`${viewPath}/WorkHoursAction`}
/>
<EmployeeWorkHoursAction
  viewPath={`${viewPath}/EmployeeWorkHoursAction`}
/>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 style={{'--pl-13-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-14-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical2}`}
>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 backgroundColor={dtColorsNeutral200}
 marginBottom={dtSpaceXxs}
 marginTop={dtSpaceXxs}
/>
</div>
<PatientsAction
  viewPath={`${viewPath}/PatientsAction`}
/>
<OrdersAction
  viewPath={`${viewPath}/OrdersAction`}
/>
<NotesAction
  viewPath={`${viewPath}/NotesAction`}
/>
<WorkflowsAction
  viewPath={`${viewPath}/WorkflowsAction`}
/>
<div
  data-testid="Content.Vertical:3"
  data-view-path={viewPath}
 style={{'--pl-13-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-14-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical3}`}
>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 backgroundColor={dtColorsNeutral200}
 marginBottom={dtSpaceXxs}
 marginTop={dtSpaceXxs}
/>
</div>
<KpisAction
  viewPath={`${viewPath}/KpisAction`}
/>
<ReportsAction
  viewPath={`${viewPath}/ReportsAction`}
/>
<FinancialAction
  viewPath={`${viewPath}/FinancialAction`}
/>
<MarketingAction
  viewPath={`${viewPath}/MarketingAction`}
>
{childProps => (
<div
  data-testid="Content.Vertical:4"
  data-view-path={viewPath}
 className="views-block"
/>
)}
</MarketingAction>
<div
  data-testid="Content.Vertical:5"
  data-view-path={viewPath}
 style={{'--pl-13-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-14-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical4}`}
>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 backgroundColor={dtColorsNeutral200}
 marginBottom={dtSpaceXxs}
 marginTop={dtSpaceXxs}
/>
</div>
<SupportAction
  viewPath={`${viewPath}/SupportAction`}
/>
<RoadmapAction
  viewPath={`${viewPath}/RoadmapAction`}
/>
<SettingsAction
  viewPath={`${viewPath}/SettingsAction`}
/>
<Apps
  viewPath={`${viewPath}/Apps`}
/>
<div
  data-testid="Content.Vertical:6"
  data-view-path={viewPath}
 style={{'--pl-13-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-14-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs}}
 className={`views-block ${styles.Vertical5}`}
>
<TysiaHorizDivider
  viewPath={`${viewPath}/TysiaHorizDivider`}
 backgroundColor={dtColorsNeutral200}
 marginBottom={dtSpaceXxs}
 marginTop={dtSpaceXxs}
/>
</div>
<LogoutAction
  viewPath={`${viewPath}/LogoutAction`}
/>
</div>
)}
</FloatingPortal>
{children}
</React.Fragment>)
}